import { useSyncExternalStore } from 'react';
import { translate } from './catalog';

export const LANGUAGE_STORAGE_KEY = 'baytbuddy_language';
const readLanguage = () => {
  try { return localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'ar' ? 'ar' : 'en'; }
  catch { return 'en'; }
};
let language = readLanguage();
const listeners = new Set();
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const getSnapshot = () => language;

function updateDocument() {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language === 'ar' ? 'ar-SA' : 'en';
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }
}
updateDocument();

export function setLanguage(next) {
  if (next !== 'ar' && next !== 'en') return;
  language = next;
  try { localStorage.setItem(LANGUAGE_STORAGE_KEY, next); } catch { /* Session switching still works. */ }
  updateDocument();
  listeners.forEach(listener => listener());
}
if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key === LANGUAGE_STORAGE_KEY) {
      language = event.newValue === 'ar' ? 'ar' : 'en';
      updateDocument();
      listeners.forEach(listener => listener());
    }
  });
}
export const t = (value, params) => translate(value, language, params);
export function formatCount(count, noun) {
  if (language === 'en') return `${count} ${noun}${count === 1 ? '' : 's'}`;
  const forms = {
    post: ['إعلان', 'إعلان واحد', 'إعلانين', 'إعلانات'],
    listing: ['إعلان', 'إعلان واحد', 'إعلانين', 'إعلانات'],
    'shortlisted room': ['غرفة مفضلة', 'غرفة مفضلة واحدة', 'غرفتين مفضلة', 'غرف مفضلة'],
  }[noun];
  if (!forms) return `${count} ${t(noun)}`;
  const category = new Intl.PluralRules('ar').select(count);
  if (category === 'one') return forms[1];
  if (category === 'two') return forms[2];
  return `${count} ${category === 'few' || category === 'zero' ? forms[3] : forms[0]}`;
}
export function useLanguage() {
  const current = useSyncExternalStore(subscribe, getSnapshot, () => 'en');
  return { language: current, setLanguage, t };
}
